import { MouseEventHandler } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { useAuthContext } from '../../../../../contexts/authContext';
import variables from '../../../../../shared/styles/settings.module.scss';
import { ASSISTANT, CHAT_ASSISTANT_EDIT } from '../../../../../routes/paths';
import {
    asyncDeleteChatAssistant,
    asyncUpdateChatAssistantLink,
} from '../../../../../services/chat-assistant.service';

export const useChatAssistantActions = (
    id: string | number,
    reloadData: () => void,
    assistantLinkId?: string
) => {
    const navigate = useNavigate();
    const { modeTheme } = useAuthContext();
    const iconColor =
        modeTheme === 'darkMode' ? variables.darkColor : variables.primaryColor;

    const handleGoToAssistant:
        | MouseEventHandler<HTMLButtonElement>
        | undefined = (e) => {
            e.stopPropagation();
            window.open(`${ASSISTANT}/${assistantLinkId ?? id}`, '_blank');
        };

    const handleEdit: MouseEventHandler<HTMLButtonElement> | undefined = (
        e
    ) => {
        e.stopPropagation();
        navigate(`${CHAT_ASSISTANT_EDIT}/${id}`);
    };

    const handleUpdateLink: MouseEventHandler<HTMLButtonElement> | undefined = (
        e
    ) => {
        e.stopPropagation();
        Swal.fire({
            title: 'Actualizar',
            text: '¿Está seguro que desea actualizar el link del asistente?',
            icon: 'question',
            iconColor,
            showDenyButton: true,
            denyButtonText: 'NO',
            denyButtonColor: iconColor,
            confirmButtonText: 'SI',
            confirmButtonColor: iconColor,
            customClass: 'swal-wide-class',
        }).then((response) => {
            if (response.isConfirmed) {
                asyncUpdateChatAssistantLink(id).then((body: any) => {
                    const isSuccessful = body.items !== undefined;
                    Swal.fire({
                        text: isSuccessful
                            ? 'Link actualizado con éxito'
                            : 'Error al actualizar el link',
                        icon: isSuccessful ? 'success' : 'error',
                        iconColor,
                    });
                    if (isSuccessful) reloadData();
                });
            }
        });
    };

    const handleDelete = () => {
        Swal.fire({
            title: 'Eliminar',
            text: '¿Está seguro que desea eliminar el registro?',
            icon: 'question',
            iconColor,
            showDenyButton: true,
            denyButtonText: 'NO',
            denyButtonColor: iconColor,
            confirmButtonText: 'SI',
            confirmButtonColor: iconColor,
            customClass: 'swal-wide-class',
        }).then((response) => {
            if (response.isConfirmed) {
                asyncDeleteChatAssistant(id).then((body: any) => {
                    const isSuccessful = body.items !== undefined;
                    Swal.fire({
                        text: isSuccessful
                            ? 'Registro eliminado con éxito'
                            : 'Error al eliminar el registro',
                        icon: isSuccessful ? 'success' : 'error',
                        iconColor,
                    });
                    if (isSuccessful) reloadData();
                });
            }
        });
    };

    return {
        handleGoToAssistant,
        handleEdit,
        handleDelete,
        handleUpdateLink,
    };
};
